// @core/api/endpoints/chat/list_chat_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListChatPoliciesResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List chat policies
 * Returns chat policies, optionally filtered by scope entity type.
 */
export async function ListChatPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListChatPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/chat-policies`;
  const requestOptions = options;
  return client.get<ListChatPoliciesResponse>(requestPath, { ...requestOptions, params });
}
